import { render, staticRenderFns } from "./ScrollbarOverlay.vue?vue&type=template&id=65e4ef03&"
import script from "./ScrollbarOverlay.vue?vue&type=script&lang=js&"
export * from "./ScrollbarOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports